function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 1L16 6.22222L10.7778 5.22222L12.4 3.6C11.2711 2.48 9.71556 1.77778 8 1.77778C4.56889 1.77778 1.77778 4.56889 1.77778 8C1.77778 11.4311 4.56889 14.2222 8 14.2222C11.4311 14.2222 14.2222 11.4311 14.2222 8H16C16 12.4178 12.4178 16 8 16C3.58222 16 0 12.4178 0 8C0 3.58222 3.58222 0 8 0C10.2133 0 12.2133 0.897778 13.6533 2.34667L15 1ZM7.11108 8.88886V4.44442H8.44442V8.13331L11.5733 9.99108L10.8889 11.1289L7.11108 8.88886Z",
  fill: "white"
});

var SvgUpdate16 = function SvgUpdate16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdate16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/update_16.b7aa3a3e.svg";
export { ForwardRef as ReactComponent };